import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '../../common/RouterHooks';
import SideNavContainer, { SideNavContainerProps } from './containers/SideNavContainer';
import css from './SideNav.scss';

const SideNav: React.FC<SideNavContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <SideNavContainer {...containerProps} t={t} routeProps={routeProps}>
            {(props) => {
                if (props.showMenu) {
                    return (
                        <div className={css.navButtonDiv} >
                            <button onClick={props.onClick} className={css.navButton}>
                                <img id="user-menu-icon" src={props.menuIcon} className={css.navImage} />
                            </button>
                        </div>
                    );
                }
                return null;
            }}
        </SideNavContainer>
    );
};

export default SideNav;
